export default "__VITE_ASSET__CIjwcY0Z__"